import { createReducer, on } from '@ngrx/store';
import * as priceSheetActions from '../../actions/master-data/price.sheet.actions';
import { PriceSheetState } from '../../states/master-data/price.sheet.state';

export const initialState: PriceSheetState = {loading: false, error: undefined,  priceSheets: [], successMessage: ''};

export const priceSheetReducer = createReducer(
    initialState,
    on(priceSheetActions.loadPriceSheets, (state) => ({ ...state, loading: true, error: undefined, successMessage: '' })),
    on(priceSheetActions.addPriceSheetSuccess, (state, { message }) => ({
        ...state,
        successMessage: message,
        error: undefined
    })),
    on(priceSheetActions.loadPriceSheetsSuccess, (state, {priceSheets}) => ({ ...state, loading: false, priceSheets, error: undefined })),
    on(priceSheetActions.addPriceSheet, (state, {priceSheet}) => ({...state, priceSheets: [...state.priceSheets, priceSheet], error: undefined})),
    on(priceSheetActions.updatePriceSheet, (state, {priceSheet}) => ({...state, priceSheets: state.priceSheets.map(r => r.id === priceSheet.id ? priceSheet : r), error: undefined})),
    on(priceSheetActions.updatePriceSheetSuccess, (state, { message }) => ({
        ...state,
        successMessage: message ?? 'Price sheet updated successfully',
        error: undefined
    })),
    on(priceSheetActions.deletePriceSheet, (state, {id}) => ({...state, priceSheets: state.priceSheets.filter(r => r.id !== id), error: undefined})),
    on (priceSheetActions.deletePriceSheetSuccess, (state, { message }) => ({
        ...state,
        successMessage: message ?? 'Price sheet deleted successfully',
        error: undefined
    })),
    on(priceSheetActions.loadPriceSheetFailure, (state, { error }) => ({ ...state, loading: false, error, }))
);